module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('card-modal', {
    attrs: {
      "visible": true,
      "title": _vm.title,
      "showPreview": false,
      "okText": 'Confirmar',
      "disableOk": false
    }
  }, [_c('div', {
    staticClass: "content",
    attrs: {
      "id": "modal-edit-content"
    }
  }, [_c('span', {
    staticClass: "icon is-large modal-center-icon"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "has-text-centered"
  }, [_vm._v("\n\t\tTem a certeza que pretende apagar este utlizador?\n      ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b0ab2506!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/UserDeleteModal.vue
// module id = 351
// module chunks = 1